import FiledsCard from "../../Components/FiledsCard/FiledsCard";
import Input from "../../Components/Input/Input";
import "./CardInputFields.scss";

const CardInputFields = ({ touched, data, formikhandleInputChange, alldata, errors, handleBlur }) => {
  return (
    <div className="container">
      <FiledsCard>
        <div className="headding">{/* <p>{data.name}</p> */}</div>
        <div className="CardInputField">
          {data.Subfields.map((e) => {
            return (
              <>
                <div key={e.id} className="Sidebysideinput">
                  <Input
                    EMTQuery=""
                    checked={""}
                    InputConfig={e}
                    // field={props.text}
                    name={e.name}
                    value={e.value || alldata[e.name]}
                    label={e.label}
                    disable={e.disable}
                    type={e.type}
                    modalform={true}
                    Iconinside={true}
                    handleInputChange={formikhandleInputChange}
                    // handleInputChange={props.handleChange}
                    dropdowndata={e.dropdowncontent}
                    hasApiCallback={e.hasApiCallback}
                    handleBlur={handleBlur}
                    min={e.min}
                    max={e.max ? e.max : undefined}
                  />
                  {/* <p
                  style={{
                    padding: "0px",
                    margin: "0px",
                    fontSize: "11px",
                    color: "red",
                    marginLeft:"8px",
                    marginBottom:"3px"

                  }}
                >

                  {touched[e.name] &&errors[e.name] ?errors[e.name].split("_").join(" "):""}
                </p> */}
                </div>
              </>
            );
          })}
        </div>
      </FiledsCard>
    </div>
  );
};

export default CardInputFields;
